import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const solicitarRecursoMunicipioRoutes: Routes = [
  {
    path: 'solicitar-recurso-municipio',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./solicitar-recurso-municipio.component').then(
            (m) => m.SolicitarRecursoMunicipioComponent,
          ),
        data: {
          title: 'Interposição de Recurso Município',
          roles: [Role.SOLICITAR_RECURSO_MUNICIPIO_CONSULTAR],
          breadcrumb: [{ label: 'Solicitar Recurso Município', url: '/solicitar-recurso-municipio' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./solicitar-recurso-municipio-form/solicitar-recurso-municipio-form.component').then(
            (m) => m.SolicitarRecursoMunicipioFormComponent,
          ),
        data: {
          title: 'Solicitar Interposição de Recurso Município',
          roles: [Role.SOLICITAR_RECURSO_MUNICIPIO_CADASTRAR],
          breadcrumb: [
            { label: 'Solicitar Interposição de Recurso Município', url: '/solicitar-recurso-municipio' },
            { label: 'Cadastrar', url: '/solicitar-recurso-municipio/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./solicitar-recurso-municipio-form/solicitar-recurso-municipio-form.component').then(
            (m) => m.SolicitarRecursoMunicipioFormComponent,
          ),
        data: {
          title: 'Editar Interposição de Recurso Município',
          roles: [Role.SOLICITAR_RECURSO_MUNICIPIO_EDITAR],
          breadcrumb: [
            { label: 'Editar Interposição de Recurso Município', url: '/solicitar-recurso-municipio' },
            { label: 'Editar', url: '/solicitar-recurso-municipio/editar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./solicitar-recurso-municipio-form/solicitar-recurso-municipio-form.component').then(
            (m) => m.SolicitarRecursoMunicipioFormComponent,
          ),
        data: {
          title: 'Visualizar Interposição de Recurso Município',
          roles: [Role.SOLICITAR_RECURSO_MUNICIPIO_VISUALIZAR],
          breadcrumb: [
            { label: 'Visualizar Interposição de Recurso Município', url: '/solicitar-recurso-municipio' },
            { label: 'Visualizar', url: '/solicitar-recurso-municipio/visualizar' },
          ],
        },
      },
    ],
  },
];
